import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { ErrorHandler, NgModule } from '@angular/core';

import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';

import { MyApp } from './app.component';
import { LoginPage } from './../pages/login/login';

import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { ApiBaseProvider } from '../providers/api-base-service/api-base-service';
import { AuthStoreProvider } from '../providers/auth-store/auth-store';
import { ApiServiceProvider } from '../providers/api-service/api-service';
import { BrowserBackService } from '../providers/browser-back-service/browser-back-service';


@NgModule({
  declarations: [
    MyApp,
    LoginPage
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    IonicModule.forRoot(MyApp)
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    LoginPage
  ],
  providers: [
    StatusBar,
    SplashScreen,
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    ApiBaseProvider,
    AuthStoreProvider,
    ApiServiceProvider,
    BrowserBackService
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts